'use strict';

var RulesStateService = function RulesStateService() {
  var deleteButtonVisible = false;
  var duplicateButtonVisible = false;
  var selectedRows = null;
  var selectedRow = null;
  function isDeleteButtonVisible() {
    return deleteButtonVisible;
  }
  function isDuplicateButtonVisible() {
    return duplicateButtonVisible;
  }
  function setSelectedRows(rows) {
    var singleRowSelected = rows.length === 1;
    var someRowsSelected = rows.length > 0;
    selectedRows = rows;
    deleteButtonVisible = someRowsSelected;
    duplicateButtonVisible = singleRowSelected;
    selectedRow = singleRowSelected ? selectedRows[0] : null;
  }
  function getSelectedRows() {
    return selectedRows;
  }
  function getSelectedRow() {
    return selectedRow;
  }
  return {
    isDeleteButtonVisible: isDeleteButtonVisible,
    isDuplicateButtonVisible: isDuplicateButtonVisible,
    setSelectedRows: setSelectedRows,
    getSelectedRows: getSelectedRows,
    getSelectedRow: getSelectedRow
  };
};
RulesStateService.$inject = [];
module.exports = RulesStateService;